import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@my-env/environment';
import { AuthService } from '@my-services/auth.service';
import { Constants } from '@my-util/constants';
import { Helper } from '@my-util/helper';
import { ToastrService } from 'ngx-toastr';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toastr = inject(ToastrService);
  if (!environment.isReleaseMode || Helper.isNextStep) {
    // IF Login
    if (authService.isUserLogin()) {
      return true;
    }
    // IF Logout
    else {
      // const isUrlCover = state.url.includes('/');
      // const isUrl = state.url.includes('new-launches');
      // const isUrlBrok = state.url.includes('broker-profile');
      const admin = state.url.includes('admin/') !== true;
      const broker = state.url.includes('broker/') !== true;
      const postproperty = state.url.includes('post-property/') !== true;
      if (admin && broker && postproperty) {
        return true;
      }
      router.navigate([Constants.LOGIN_ROUTE], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  } else {
    toastr.error('URL manipulation/refresh not allowed.', 'Failed');
    authService.logout();
    return Helper.isNextStep;
  }
};
